/* Nutzernamen-Regeln für die Oberfläche.

   Wortgleiche Kopie von `cloudflare/src/auth/usernames.js`. Das ist bewusst
   Doppelung und keine Nachlässigkeit: der Worker ist ein eigenes Bundle, das
   Frontend kann seine Module nicht importieren. Die Alternative wäre ein
   geteiltes Paket – für eine Handvoll Regeln zu viel Apparat.

   Wichtig ist nur die Rangfolge: **verbindlich ist der Server.** Was hier
   steht, dient allein der sofortigen Rückmeldung beim Tippen. Weichen beide
   je voneinander ab, gewinnt die Antwort der API – und dann gehört diese
   Datei nachgezogen, nicht die andere.

   Warum die Regeln so sind, steht drüben im Kommentar. */

export const USERNAME_MIN = 3;
export const USERNAME_MAX = 20;

const GESPERRT = new Set([
  'mimorio', 'admin', 'administrator', 'moderator', 'mod', 'support', 'team',
  'staff', 'system', 'root', 'owner', 'official', 'offiziell', 'hilfe', 'help',
  'service', 'kontakt', 'contact', 'info', 'noreply', 'no_reply', 'postmaster',
  'abuse', 'security', 'sicherheit', 'datenschutz', 'privacy', 'legal',
  'api', 'www', 'app', 'auth', 'login', 'logout', 'register', 'signup',
  'account', 'settings', 'profile', 'user', 'users', 'me', 'null', 'undefined',
  'anonymous', 'guest', 'gast', 'deleted', 'geloescht', 'bot',
]);

export function usernameProblem(name) {
  const n = String(name == null ? '' : name).trim();

  if (n.length < USERNAME_MIN) return `Der Name braucht mindestens ${USERNAME_MIN} Zeichen.`;
  if (n.length > USERNAME_MAX) return `Der Name darf höchstens ${USERNAME_MAX} Zeichen haben.`;
  if (/\s/.test(n)) return 'Leerzeichen sind im Namen nicht erlaubt.';
  if (!/^[a-zA-Z]/.test(n)) return 'Der Name muss mit einem Buchstaben beginnen.';
  if (!/^[a-zA-Z0-9_]+$/.test(n)) return 'Erlaubt sind nur Buchstaben, Zahlen und Unterstriche.';
  if (n.endsWith('_')) return 'Der Name darf nicht mit einem Unterstrich enden.';
  if (n.includes('__')) return 'Zwei Unterstriche hintereinander sind zu leicht zu übersehen.';
  if (GESPERRT.has(n.toLowerCase())) return 'Dieser Name ist reserviert. Bitte wähle einen anderen.';
  return null;
}
